var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-view-wrapper"},[_c('tree-view-item',{staticClass:"tree-view-item-root",attrs:{"data":_vm.parsedData,"max-depth":_vm.maxDepth,"currentDepth":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }